<div class="loading-indicator" *ngIf="progressBehavior | async">
    <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<div style="display: flex; flex-direction: column; align-items: flex-start; gap: 10px;">
    <!-- Form Start -->
    <form [formGroup]="dbForm">

        <!-- Server and Port -->
        <div style="display: flex; gap: 10px;">
            <mat-form-field style="width: 350px" appearance="outline">
                <mat-label>Server</mat-label>
                <input [(ngModel)]="viewModel.databaseServer" formControlName="databaseServer" 
                type="text" matInput placeholder="Enter database server host or IP address" required>
            </mat-form-field>

            <mat-form-field style="width: 75px" appearance="outline">
                <mat-label>Port</mat-label>
                <input [(ngModel)]="viewModel.portNumber" formControlName="portNumber" appIntegerPositiveOnly type="number" matInput placeholder="Port" required> 
              </mat-form-field>
        </div>

        <!-- Database Name, User Name, Password, and Test Connection -->
        <div style="display: flex; gap: 10px;">
            <mat-form-field style="width: 250px;" appearance="outline">
                <mat-label>Database Name</mat-label>
                <input [(ngModel)]="viewModel.databaseName" formControlName="databaseName" type="text" matInput placeholder="Enter database name" required>
            </mat-form-field>

            <mat-form-field style="width: 250px;" appearance="outline">
                <mat-label>User Name</mat-label>
                <input [disabled]="viewModel.isIntegratedSecurity" formControlName="userName" [(ngModel)]="viewModel.userName" type="text" matInput placeholder="Enter username" required autocomplete="off">
            </mat-form-field>

            <mat-form-field style="width: 250px;" appearance="outline">
                <mat-label>Password</mat-label>
                <input [disabled]="viewModel.isIntegratedSecurity" formControlName="password" [(ngModel)]="viewModel.password" type="password" matInput placeholder="Enter password" required autocomplete="new-password">
            </mat-form-field>

          

            <mat-form-field style="width: 200px;" appearance="outline">
                <mat-label>Connection Timeout(s)</mat-label>
                <input [(ngModel)]="viewModel.connectionTimeout"  matInput type="number" placeholder="60" min="0">
            </mat-form-field>
            <button 
            [style.background-color]="viewModel.isConnectionValid ? '#3F51B5' : '#797979'"
            type="button" mat-raised-button
            (click)="testConnection()"  style="align-self: center; position: relative; ">
            Connect to Database
        </button>
        </div>

        <!-- List of Tables -->
        <div style="display: flex; gap: 10px;">
            <mat-form-field style="width: 195px" appearance="outline">
                <mat-label>List of Tables</mat-label>
                <input type="text" placeholder="Select Table" matInput [matAutocomplete]="auto" [(ngModel)]="viewModel.tableName" [formControl]="control">
                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getDatetimeField($event.option.value,true)">
                    <mat-option *ngFor="let option of tablelistsOptions | async" [value]="option">
                        {{ option }}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
            <button 
                [style.background-color]="viewModel.isConnectionValid ? '#3F51B5' : '#797979'"
                type="button" mat-raised-button
                [disabled]="!viewModel.isConnectionValid"
                (click)="refreshTableList()"  style="align-self: center; position: relative;">
                Retrieve Table List
            </button>
        </div>
    </form> 
        <!-- Timestamp and Date/Time Range -->
        <div style="display: flex; gap: 10px;">
            <mat-form-field style="width: 195px" appearance="outline">
                <mat-label>Timestamp Field</mat-label>
                <mat-select [(ngModel)]="viewModel.timestampField" (selectionChange)="onDateChange(viewModel.timestampField)">
                    <mat-option *ngFor="let col of datetimeField" [value]="col.name">
                        {{ col.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field style="width: 195px" appearance="outline">
                <mat-label>Begin Date Range</mat-label>
                <input [(ngModel)]="viewModel.beginDate" matInput [matDatepicker]="startDatePicker" >
                <mat-datepicker-toggle matSuffix [for]="$any(startDatePicker)"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field style="width: 195px" appearance="outline">
                <mat-label>Begin Time Range</mat-label>
                <input [(ngModel)]="viewModel.beginTime" matInput [ngxTimepicker]="startTimePicker" >
                <ngx-material-timepicker #startTimePicker></ngx-material-timepicker>
            </mat-form-field>
            

            <mat-form-field style="width: 195px" appearance="outline">
                <mat-label>End Date Range</mat-label>
                <input [(ngModel)]="viewModel.endDate" matInput [matDatepicker]="endDatePicker" >
                <mat-datepicker-toggle matSuffix [for]="$any(endDatePicker)"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field style="width: 195px" appearance="outline">
                <mat-label>End Time Range</mat-label>
                <input [(ngModel)]="viewModel.endTime" matInput [ngxTimepicker]="endTimePicker" >
                <ngx-material-timepicker #endTimePicker></ngx-material-timepicker>
            </mat-form-field>

            <button 
                [style.background-color]="viewModel.isConnectionValid ? '#3F51B5' : '#797979'" 
                type="button" mat-raised-button
                [disabled]="!viewModel.isConnectionValid"
                (click)="BuildQuery()"  style="align-self: center; position: relative; ">
                Build Query
            </button>
        </div>
  
    <!-- Form End -->

    <!-- SQL Code Extensions (Outside the Form) -->
    <div style="width: 100%;">
        <mat-form-field style="width: 100%" appearance="outline">
            <mat-label>SQL Code Extensions</mat-label>
            <textarea [(ngModel)]="viewModel.sqlCodeExtention" rows="5" cols="40" matInput placeholder="Enter SQL command to query data set"></textarea>
        </mat-form-field>
    </div>

    <!-- SQL Code Sent (Outside the Form) -->
    <div style="width: 100%;">
        <mat-form-field style="width: 100%" appearance="outline">
            <mat-label>SQL Code Sent</mat-label>
            <textarea [(ngModel)]="viewModel.sqlCommand" rows="7" cols="40" matInput disabled></textarea>
        </mat-form-field>
    </div>
</div>
